/** When your routing table is too long, you can split it into small modules**/
/* Layout */
import Layout from '@/layout'

/* Router Modules */
const accountRouters = {
  path: '/account',
  component: Layout,
  name: 'account',
  meta: {
    title: '账号管理',
    icon: 'el-icon-files'
  },
  children: [
    {
      path: 'superAdmin',
      component: () => import('@/views/account/superAdmin/list'),
      name: 'SuperAdminList',
      meta: { title: '集团员工账号管理' }
    },
    {
      path: 'role',
      component: () => import('@/views/account/role/index'),
      name: 'Role',
      meta: { title: '角色管理' },
      redirect: '',
      hidden: true,
      children: [
        {
          path: 'list',
          component: () => import('@/views/account/role/list'),
          name: 'RoleList',
          meta: {
            title: '角色列表',
            noCache: true
          }
        },
        {
          path: 'create',
          component: () => import('@/views/account/role/create'),
          name: 'CreateUserRole',
          hidden: true,
          meta: { title: '角色创建', noCache: true }
        },
        {
          path: 'edit/:id(\\d+)',
          component: () => import('@/views/account/role/edit'),
          name: 'EditUserRole',
          meta: { title: '角色编辑', noCache: true },
          hidden: true
        }
      ]
    }
  ]
}

export default accountRouters
